import React from "react";

const SwButton = ({
  children,
  variant = "primary",  // primary, dark, dark-outline, light-outline, danger, danger-outline, light-grey
  size = "md",  // sm, md
  disabled = false, // disable the button
  className = "", // additional class names
  type = "button", // button type
  onClick, // click event handler

  block = "no", // block button

  /* Link support */
  href, // link href
  target, // link target

  /* Icon support */
  icon = null, // icon
  iconPosition = "start", // still supported when not loading

  /* Loading */
  loading = false, // loading

  ...rest
}) => {
  const Component = href ? "a" : "button";  // if href is provided, it will be a link, otherwise it will be a button
  const isDisabled = disabled || loading; // disable the button if disabled or loading

  return (
    <Component
      href={href}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      type={!href ? type : undefined}
      disabled={!href ? isDisabled : undefined}
      onClick={!loading ? onClick : undefined}
      className={`btn sw-btn sw-btn-${variant} sw-btn-${size}
        ${block === "yes" ? "sw-btn-block" : ""}
        ${href ? "sw-btn-link" : ""}
        ${loading ? "sw-btn-loading" : ""}
        ${className}`}
      {...rest}
    >
      {/* ===== START ICON OR SPINNER ===== */}
      {loading ? (
        <span className="sw-btn-spinner me-2" />
      ) : (
        icon &&
        iconPosition === "start" && (
          <span className="sw-btn-icon sw-btn-icon-start">
            {icon}
          </span>
        )
      )}

      {/* ===== TEXT ===== */}
      <span className="sw-btn-text">{children}</span>

      {/* ===== END ICON (only when not loading) ===== */}
      {!loading && icon && iconPosition === "end" && (
        <span className="sw-btn-icon sw-btn-icon-end">
          {icon}
        </span>
      )}
    </Component>
  );
};

export default SwButton;
